module.exports = {
  PAYEE_RELATIONSHIP: {
    SUPPLIER: 'SUPPLIER',
    SERVICE_PROVIDER: 'SERVICE_PROVIDER'
  }
};
